import DatePicker from '@app/src/components/Form/DatePicker'
import { Box } from '@mui/material'
import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import { useIntl } from 'react-intl'
import { isFutureDate } from '../bulkCreateExpectationLogic'
import type { BulkCreateExpectationFormData } from '../types'
import { BulkCreateExpectationFormField } from '../types'

const SetDeadlineStep: React.FC = () => {
  const { formatMessage } = useIntl()
  const { control, formState } = useFormContext<BulkCreateExpectationFormData>()
  const error = formState.errors[BulkCreateExpectationFormField.Deadline]

  return (
    <Box>
      <Controller
        name={BulkCreateExpectationFormField.Deadline}
        control={control}
        rules={{
          validate: value =>
            isFutureDate(value) || formatMessage({ id: 'bulkCreateExpectation.steps.deadline.pastDateError' }),
        }}
        render={({ onChange, value }) => (
          <DatePicker
            disablePast
            label={formatMessage({ id: 'bulkCreateExpectation.steps.deadline.placeholder' })}
            value={value ?? null}
            onChange={onChange}
            slotProps={{
              textField: {
                fullWidth: true,
                error: Boolean(error),
                helperText: (error?.message as string) ?? undefined,
              },
            }}
          />
        )}
      />
    </Box>
  )
}

export default SetDeadlineStep
